<template>
  <div class="animated fadeIn">
    <Forms ref="frmDefault" :title="'CADASTRO DE MENSAGENS AUTOMÁTICAS'" :showClearButton="true" :showSaveButton="true"
      :showBackButton="true" :disabledKeyUpEnter="true" :isModal="isModal" v-on:Clear="onClear"
      v-on:Back="$emit('Back')" v-on:Save="onSave">
      <div class="form-group">
        <div class="row">
          <div class="col-md-6 d-flex align-items-center">
            <label for="txtData" class="mb-0">
              <small v-if="form.dataInicial.required" class="text-danger">*</small>
              Data de criação
            </label>
            <div class="input-group ml-3" style="width: 150px;">
              <b-form-input class="text-center" disabled type="date"
                id="txtData"
                name="txtData"
                v-model="currentDate"
                :state="form.dataInicial.state"
              />
            </div>
          </div>
          <b-form-group label="Selecione um Provedor" label-for="cmb-provider" class="ml-3">
            <b-form-select id="mode-select" class="w-100" v-model="provedor.value" :options="provedor.options" required>
              <b-form-select-option :value="null" disabled>{{ $lang.Common.PlaceholderSelect }}</b-form-select-option>
            </b-form-select>
            <div class="invalid-feedback">
              Por favor, forneça um número válido.
            </div>
          </b-form-group>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <div class="row d-flex align-items-center justify-content-between pl-4">
              <label class="d-flex align-items-center"><small v-if="form.mensagemForaHorario.required"
                  class="text-danger">*</small>Mensagem Fora do
                Horário</label>
              <DropDownMensagensAutomaticas v-show="showDropDownForaHorario" @item-clicked="handleSelectForaHorario"
                :options="optionsForaHorario" />
            </div>
            <div class="input-group">
              <b-form-textarea rows="6" max-row="8" v-model="form.mensagemForaHorario.value"
                :state="form.mensagemForaHorario.state"></b-form-textarea>
            </div>
          </div>
          <div class="col-md-6 mt-3 mt-md-0">
            <div class="row d-flex align-items-center justify-content-between pl-4">
              <label class="d-flex align-items-center"><small v-if="form.mensagemBoasVindas.required"
                  class="text-danger">*</small>Mensagem Boas
                Vindas</label>
              <DropDownMensagensAutomaticas v-show="showDropDownBoasVindas" @item-clicked="handleSelectBoasVindas"
                :options="optionsBoasVindas" />
            </div>
            <div class="input-group">
              <b-form-textarea rows="6" max-row="8" v-model="form.mensagemBoasVindas.value"
                :state="form.mensagemBoasVindas.state"></b-form-textarea>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <br>
            <div class="row d-flex align-items-center justify-content-between pl-4">
              <label class="d-flex align-items-center"><small v-if="form.mensagemAssumir.required"
                  class="text-danger">*</small>Mensagem Assumir</label>
              <DropDownMensagensAutomaticas v-show="showDropDownAssumir" @item-clicked="handleSelectAssumir"
                :options="optionsAssumindoTransferenciaNps" />
            </div>
            <div class="input-group">
              <b-form-textarea rows="6" max-row="8" v-model="form.mensagemAssumir.value"
                :state="form.mensagemAssumir.state"></b-form-textarea>
            </div>
          </div>
          <div class="col-md-6">
            <br>
            <div class="row d-flex align-items-center justify-content-between pl-4">
              <label class="d-flex align-items-center"><small v-if="form.mensagemNps.required"
                  class="text-danger">*</small>Mensagem NPS</label>
              <DropDownMensagensAutomaticas v-show="showDropDownNps" @item-clicked="handleSelectNps"
                :options="optionsAssumindoTransferenciaNps" />
            </div>
            <div class="input-group">
              <b-form-textarea ref="inputField" rows="6" max-row="8" v-model="form.mensagemNps.value"
                :state="form.mensagemNps.state"></b-form-textarea>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <br>
            <div class="row d-flex align-items-center justify-content-between pl-4">
              <label class="d-flex align-items-center"><small v-if="form.mensagemTransferir.required"
                  class="text-danger">*</small>Mensagem
                Transferir</label>
              <DropDownMensagensAutomaticas v-show="showDropDownTranferir" @item-clicked="handleSelectTransferir"
                :options="optionsAssumindoTransferenciaNps" />
            </div>
            <div class="input-group">
              <b-form-textarea rows="6" max-row="8" v-model="form.mensagemTransferir.value"
                :state="form.mensagemTransferir.state"></b-form-textarea>
            </div>
          </div>
          <div class="col-md-6">
            <br>
            <div class="row d-flex align-items-center justify-content-between pl-4">
              <label class="d-flex align-items-center"><small v-if="form.mensagemFinalizar.required"
                  class="text-danger">*</small>Mensagem
                Finalizar</label>
              <DropDownMensagensAutomaticas v-show="showDropDownFinalizar" @item-clicked="handleSelectFinalizar"
                :options="optionsFinalizar" />
            </div>
            <div class="input-group">
              <b-form-textarea rows="6" max-row="8" v-model="form.mensagemFinalizar.value"
                :state="form.mensagemFinalizar.state"></b-form-textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br>
            <div class="row d-flex align-items-center justify-content-between pl-4">
              <label class="d-flex align-items-center"><small v-if="form.mensagemNaoReceptivo.required"
                  class="text-danger">*</small>Mensagem Não Receptivo</label>
              <DropDownMensagensAutomaticas v-show="showDropDownMensagemNaoReceptivo"
                @item-clicked="handleSelectNaoReceptivo" :options="optionsNaoReceptivo" />
            </div>
            <div class="input-group">
              <b-form-textarea rows="6" max-row="8" v-model="form.mensagemNaoReceptivo.value"
                :state="form.mensagemNaoReceptivo.state"></b-form-textarea>
            </div>
          </div>
        </div>
      </div>
    </Forms>
    <AddConfirmation ref="AddConfirmationModal"
      warnText="Após o salvamento não sera possível a edição/exclusão. Deseja confirmar esta operação?"
      :saveFunction="onSave" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import DropDownMensagensAutomaticas from '../dropdown/DropDownMensagensAutomaticas.vue'
import MensagensAutomaticasRepository from '@/shared/http/repositories/configurations/mensagensautomaticas.js'
import MensagensAutomaticasModel from '@/shared/models/configurations/mensagensautomaticasmodel.js'
import MensagensAutomaticasForms from './mensagensautomaticasadd-form.js'
import NumRepository from '@/shared/http/repositories/access/cadastroNum'

export default {
  name: 'MensagensAutomaticasAdd',
  mixins: [ActionsForm],
  components: {
    DropDownMensagensAutomaticas
  },
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tooltipStyle: {
        top: '0px',
        left: '0px'
      },
      focusedInput: null,
      optionValue: null,
      showDropDownBoasVindas: false,
      showDropDownNps: false,
      showDropDownTranferir: false,
      showDropDownAssumir: false,
      showDropDownFinalizar: false,
      showDropDownForaHorario: false,
      showDropDownMensagemNaoReceptivo: false,
      data: MensagensAutomaticasModel,
      form: MensagensAutomaticasForms,
      currentDate: this.getCurrentDate(),
      provedor: {
        value: null,
        required: true,
        options: []
      }
    }
  },
  computed: {
    optionsBoasVindas () {
      return [
        {
          label: '@NOME@',
          value: 'NOME@ '
        },
        {
          label: '@PROTOCOLO@',
          value: 'PROTOCOLO@ '
        }
      ]
    },
    optionsForaHorario () {
      return [
        {
          label: '@HORARIO_INICIAL@',
          value: 'HORARIO_INICIAL@ '
        },
        {
          label: '@HORARIO_FINAL@',
          value: 'HORARIO_FINAL@ '
        }
      ]
    },
    optionsAssumindoTransferenciaNps () {
      return [
        {
          label: '@SEU_NOME@',
          value: 'SEU_NOME@ '
        },
        {
          label: '@SEU_PRIMEIRO_NOME@',
          value: 'SEU_PRIMEIRO_NOME@ '
        },
        {
          label: '@PROTOCOLO@',
          value: 'PROTOCOLO@ '
        },
        {
          label: '@APELIDO@',
          value: 'APELIDO@ '
        }
      ]
    },
    optionsFinalizar () {
      return [
        {
          label: '@MOTIVO@',
          value: 'MOTIVO@ '
        },
        {
          label: '@SEU_PRIMEIRO_NOME@',
          value: 'SEU_PRIMEIRO_NOME@ '
        },
        {
          label: '@PROTOCOLO@',
          value: 'PROTOCOLO@ '
        },
        {
          label: '@APELIDO@',
          value: 'APELIDO@ '
        }
      ]
    },
    optionsNaoReceptivo () {
      return [
        {
          label: '@NOME@',
          value: 'NOME@ '
        },
        {
          label: '@PROTOCOLO@',
          value: 'PROTOCOLO@ '
        }
      ]
    }

  },
  watch: {
    'form.mensagemNps.value' (newValue) {
      if (newValue.endsWith('@')) {
        this.showDropDownNps = true
      } else {
        this.showDropDownNps = false
      }
    },
    'form.mensagemAssumir.value' (newValue) {
      if (newValue.endsWith('@')) {
        this.showDropDownAssumir = true
      } else {
        this.showDropDownAssumir = false
      }
    },
    'form.mensagemTransferir.value' (newValue) {
      if (newValue.endsWith('@')) {
        this.showDropDownTranferir = true
      } else {
        this.showDropDownTranferir = false
      }
    },
    'form.mensagemForaHorario.value' (newValue) {
      if (newValue.endsWith('@')) {
        this.showDropDownForaHorario = true
      } else {
        this.showDropDownForaHorario = false
      }
    },
    'form.mensagemBoasVindas.value' (newValue) {
      if (newValue.endsWith('@')) {
        this.showDropDownBoasVindas = true
      } else {
        this.showDropDownBoasVindas = false
      }
    },
    'form.mensagemFinalizar.value' (newValue) {
      if (newValue.endsWith('@')) {
        this.showDropDownFinalizar = true
      } else {
        this.showDropDownFinalizar = false
      }
    }
  },
  methods: {
    /* updatePosition () {
      // Logs removidos por segurança
      const inputField = this.$refs.inputField.$el
      if (inputField) {
        const rect = inputField.getBoundingClientRect()

        this.tooltipStyle = {
          top: `${rect.top}px`,
          left: `${rect.left}px`
        }
      }
    }, */
    handleSelectAssumir (option) {
      this.form.mensagemAssumir.value += option.value
      this.showDropDownAssumir = false
    },
    handleSelectFinalizar (option) {
      this.form.mensagemFinalizar.value += option.value
      this.showDropDownFinalizar = false
    },
    handleSelectNaoReceptivo (option) {
      this.form.mensagemNaoReceptivo.value += option.value
      this.showDropDownMensagemNaoReceptivo = false
    },
    handleSelectTransferir (option) {
      this.form.mensagemTransferir.value += option.value
      this.showDropDownTransferir = false
    },
    handleSelectForaHorario (option) {
      this.form.mensagemForaHorario.value += option.value
      this.showDropDownForaHorario = false
    },
    handleSelectBoasVindas (option) {
      this.form.mensagemBoasVindas.value += option.value
      this.showDropDownBoasVindas = false
    },
    handleSelectNps (option) {
      this.form.mensagemNps.value += option.value
      this.showDropDownNps = false
    },
    onLoad () {
      this.loadNumbers()
    },
    async loadNumbers () {
      try {
        const requestConfig = {
          params: {
            active: 1
          }
        }
        const response = await NumRepository.getEnvAll(requestConfig)
        this.provedor.options = response.data.content.map(x => ({
          text: x.name,
          value: x.id
        }))
      } catch (error) {
        console.error('Erro ao carregar números:', error)
      }
    },
    onClear () {
      this.form.mensagemForaHorario.value = ''
      this.form.mensagemNps.value = ''
      this.form.mensagemFinalizar.value = ''
      this.form.mensagemTransferir.value = ''
      this.form.mensagemAssumir.value = ''
      this.form.mensagemBoasVindas.value = ''
    },
    onAdd () {
      Tools.ClearDataForms(this.form, this.data)

      this.provedor.value = null
      this.provedor.options = []
      this.loadNumbers()
      this.currentDate = this.getCurrentDate()
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        Tools.SetValueInForm(this.form, this.data, obj)

        if (obj.provedor) {
          this.provedor.value = obj.provedor.id
          this.provedor.options = [{
            text: obj.provedor.name,
            value: obj.provedor.id
          }]
        }

        loading.pop()
      }
    },
    onCreate () {
      loading.push()
      this.data.dataInicial = this.currentDate
      if (this.data.dataInicial) {
        this.data.dataInicial = this.data.dataInicial + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }

      this.data.idProvedor = parseInt(this.provedor.value)

      MensagensAutomaticasRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.dataInicial = this.currentDate
      if (this.data.dataInicial) {
        this.data.dataInicial = this.data.dataInicial + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }

      this.data.idProvedor = parseInt(this.provedor.value)

      MensagensAutomaticasRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    getCurrentDate () {
      const date = new Date()
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0') // +1 porque os meses começam do 0
      const year = date.getFullYear()
      return `${year}-${month}-${day}`
    }
  }
}
</script>
<style>
.bdrown {
  position: sticky;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/mensagensautomaticas/components/add/mensagensautomaticasadd.vue